<template>
  <div class="order-status">
    <div style="padding-bottom:80px">
      <div class="title-wrap">
        <div class="img" @click="$router.push('/my-order')">
          <div class="icon">
            <img src="../assets/images/left.png" alt />
          </div>
        </div>
        <span>订单详情</span>
      </div>
      <!-- 订单状态 -->
      <div class="order-type">
        <span>{{typeText}}</span>
      </div>
      <!-- 地址信息 -->
      <div class="address-wrap">
        <div class="icon">
          <img src="../assets/images/order/address.png" alt />
        </div>
        <div>
          <p>{{order.receiver}} {{order.phone}}</p>
          <p class="address">{{order.address}}</p>
        </div>
      </div>
      <!-- 订单列表 -->
      <div class="order-wrap">
        <div :class="rotate ? 'open-wrap' : 'close-wrap'">
          <van-card
            :num="item.qty"
            :price="item.unitPrice"
            :title="item.model"
            :thumb="item.imgAddress"
            v-for="(item,index) in order.detailVOS"
            :key="index"
            @click="$router.push({name:'productDetails',query:{productId:item.stockId}})"
          >
            <div slot="desc" class="brand">
              <p>品牌：{{item.brand}}</p>
              <p>封装规格：{{item.pack}}</p>
            </div>
          </van-card>
        </div>
        <div class="piece" @click="orderListOpen" v-if="orderNum > 1">
          <span>共{{orderNum}}件</span>
          <van-icon
            name="arrow-down"
            style="vertical-align:-1px;margin-left:5px"
            :class="rotate ? 'up-arrow' :'bottom-arrow'"
          />
        </div>
      </div>
      <!-- 订单信息 -->
      <div class="order-message">
        <ul>
          <li>
            <p class="invioce">{{invoiceType}}-{{invoiceTitle}}</p>
          </li>
          <li>
            <p>付款方式</p>
            <span class="payment">{{payType}}</span>
          </li>
          <li>
            <div>
              <p>商品金额</p>
              <span>￥{{order.modelAmount}}</span>
            </div>
            <div>
              <p>运费</p>
              <span>￥{{order.logisticsFee}}</span>
            </div>
            <div class="order-price">
              <p>实付金额</p>
              <span>￥{{order.totalAmount}}</span>
            </div>
          </li>
          <li>
            <div>
              <p>订单号</p>
              <span>{{order.sno}}</span>
            </div>
            <div>
              <p>下单时间</p>
              <span>{{order.createdTime}}</span>
            </div>
            <div>
              <p>订单备注</p>
              <span>{{order.remark}}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 底部 -->
    <div class="order-footer">
      <button v-if="orderType == 5" @click="receipt">确认收货</button>
      <button v-if="orderType == 9" @click="Lifting">确认自提</button>
      <div v-if="orderType == 1">
        <button class="cancel" @click="cancel">取消订单</button>
        <span class="hr"></span>
        <button class="pay" @click="goPayment">立即支付</button>
      </div>
    </div>
  </div>
</template>

<script>
import { SaleOrderDetail, Lifting, Receipt, CancelOrder } from "../request/api";
export default {
  data() {
    return {
      orderSno: "",
      rotate: false,
      order: {},
      typeText: "", //订单类型文字
      payType: "", //支付方式
      orderNum: 0, //商品件数
      invoiceType: "", //发票类型
      invoiceTitle: "", //发票抬头
      orderType: "" //订单类型
    };
  },
  created() {
    this.getOrderDetail();
  },
  methods: {
    orderListOpen() {
      this.rotate = !this.rotate;
    },
    //获取订单信息
    getOrderDetail() {
      this.orderSno = this.$route.query.sno;
      SaleOrderDetail(this.orderSno).then(res => {
        if (res.data) {
          this.order = res.data;
          this.typeText = res.data.status.desc;
          this.orderType = res.data.status.value;
          this.payType = res.data.payType.desc;
          this.orderNum = res.data.detailVOS.length;
          if (res.data.invoiceVO) {
            this.invoiceType = res.data.invoiceVO.invoiceType.desc;
            this.invoiceTitle = res.data.invoiceVO.invoiceTitle;
          }
        }
      });
    },
    //确认自提
    Lifting() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否确认自提"
        })
        .then(() => {
          Lifting(this.orderSno).then(res => {
            if (res.status == 200) {
              this.$toast.success({
                message: "确认成功",
                duration: 700
              });
              this.$router.push({
                name: "main"
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    //确认收货
    receipt() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否确认收货"
        })
        .then(() => {
          Receipt(this.orderSno).then(res => {
            if (res.status == 200) {
              this.$toast.success({
                message: "确认成功",
                duration: 700
              });
              this.$router.push({
                name: "main"
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    //取消订单
    cancel() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否取消订单"
        })
        .then(() => {
          CancelOrder(this.orderSno).then(res => {
            if (res.status == 200) {
              this.$toast.success({
                message: "取消成功",
                duration: 700
              });
              this.$router.push({
                name: "main"
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },

    //去支付
    goPayment() {
      if (this.order.payType.value == 1 || this.order.payType.value == 2) {
        this.$router.push({
          name: "alipy",
          query: {
            sno: this.order.sno
          }
        });
      } else {
        this.$router.push({
          name: "offline-pay",
          query: {
            sno: this.order.sno
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.title-wrap {
  background: #fff;
  text-align: center;
  color: #333;
  font-size: 34px;
  width: 100%;
  height: 90px;
  line-height: 90px;
  box-sizing: border-box;
  position: sticky;
  border-bottom: 1px solid #f2f2f2;
  top: 0;
  z-index: 99;
  .icon {
    height: 43px;
    width: 43px;
    float: left;
    margin: 10px 0 0 30px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
// 订单状态
.order-type {
  width: 100%;
  height: 116px;
  line-height: 116px;
  background: linear-gradient(90deg, #ff9900 0%, #ff6600 100%),
    linear-gradient(#e6441c, #e6441c);
  padding: 0 60px;
  box-sizing: border-box;
  color: #fff;
  font-size: 36px;
}
// 地址信息
.address-wrap {
  background: #fff;
  padding: 30px;
  font-size: 28px;
  display: flex;
  .icon {
    width: 48px;
    height: 48px;
    margin-right: 20px;
    display: inline-block;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .address {
    width: 503px;
    line-height: 40px;
    margin-top: 10px;
    color: #808080;
  }
}
// 订单列表
.order-wrap {
  margin: 20px 0;
  background: #fff;
  padding-bottom: 30px;
  border-top: 20px solid #f5f5f5;
  border-bottom: 20px solid #f5f5f5;
  .brand {
    color: #666;
    font-size: 26px;
    line-height: 40px;
  }
}
.open-wrap {
  height: auto;
}
.close-wrap {
  height: 220px;
  overflow: hidden;
}
.piece {
  width: 690px;
  height: 45px;
  line-height: 45px;
  background: #e6e6e6;
  text-align: center;
  margin: 0 30px;
  font-size: 26px;
  .up-arrow {
    transition: 0.3s;
    transform: rotate(180deg);
  }
  .bottom-arrow {
    transition: 0.3s;
    transform: rotate(0);
  }
}
.van-card__thumb {
  width: 150px;
  height: 150px;
  margin-right: 20px;
  border: 1px solid #f2f2f2;
}
.van-card {
  padding: 20px 30px;
  background: #fff;
}
.van-card__title {
  font-size: 30px;
  color: #333;
  line-height: 40px;
  margin-bottom: 5px;
  max-height: 6.267vw;
}
.van-card__price {
  font-size: 26px;
  color: #333;
  margin-top: 12px;
}
.van-card:not(:first-child) {
  margin-top: 0;
  border-top: 1px solid #f2f2f2;
}
// 订单信息
.order-message {
  background: #fff;
  padding: 0 30px;
  margin-bottom: 100px;
  ul {
    li {
      padding: 30px 0;
      color: #333;
      font-size: 28px;
      .invioce {
        width: 457px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .look {
        color: #808080;
      }
      .look,
      .payment {
        float: right;
        margin-top: -25px;
      }
      div {
        display: flex;
        line-height: 50px;
        span {
          flex: 1;
          text-align: right;
        }
      }
      .order-price {
        font-size: 30px;
        font-weight: bold;
        span {
          color: #ff6600;
        }
      }
    }
    li:not(last-child) {
      border-bottom: 1px solid #f2f2f2;
    }
  }
}
// footer
.order-footer {
  width: 100%;
  height: 108px;
  position: fixed;
  bottom: 0;
  background: #fff;
  border-top: 1px solid #f2f2f2;
  text-align: right;
  padding-right: 30px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  button {
    width: 200px;
    height: 58px;
    border-radius: 10px;
    background: #fff;
    border: 1px solid #ff9900;
    font-size: 25px;
    color: #ff9900;
  }
  button:last-chils {
    margin-left: 10px;
  }
  .pay {
    background: #ff9900;
    color: #fff;
    margin-left: 10px;
  }
  .cancel {
    border: 1px solid #f2f2f2;
    color: #666;
  }
  .hr {
    width: 10px;
    display: inline-block;
  }
}
</style>